import { create } from 'zustand';
import apiClient from '../api/api';
import { API_ENDPOINTS } from '../endpoints';
import uiDefaultConfig from '../config/uiDefaultConfig';

const useUIConfigStore = create((set, get) => ({
  config: uiDefaultConfig,
  loading: false,
  initialized: false,
  error: null,
  fetchUIConfig: async () => {
    const { initialized, loading } = get();
    if (initialized || loading) return;
    set({ loading: true, error: null });
    try {
      const resp = await apiClient.get(API_ENDPOINTS.getColorCodes || '/rs/colorcodes/enoch/admin', {
        headers: { 'Cache-Control': 'no-cache' },
      });
      const data = resp?.data?.data || resp?.data || {};
      if (data && Object.keys(data).length > 0) {
        const mergedConfig = { ...uiDefaultConfig, ...data };
        if (uiDefaultConfig.components && data.components) {
          mergedConfig.components = { ...uiDefaultConfig.components, ...data.components };
        }
        set({ config: mergedConfig, initialized: true, loading: false });
        return;
      }
    } catch (error) {
      console.error('Failed to load remote UI config', error);
    }
    set({ config: uiDefaultConfig, error: null, initialized: true, loading: false });
  },
}));

export default useUIConfigStore;